/**
 * Eggplant override for vault's primary `Button`. Vault merges `style` shallowly,
 * so every state key has to be replaced or its purple/blue colors leak through.
 */
export const EGGPLANT_BUTTON_STYLE = {
    backgroundColor: 'var(--color-eggplant)',
    boxShadow: 'none',
    '&:hover': { backgroundColor: 'var(--color-eggplant)' },
    '&:focus': {
        backgroundColor: 'var(--color-eggplant)',
        boxShadow: 'none',
        outline: '2px solid var(--color-eggplant)',
        outlineOffset: '2px'
    },
    '&:active': { backgroundColor: 'var(--color-eggplant)', boxShadow: 'none' }
};
